module.exports = __webpack_public_path__ + "media/images/app/collections/collection-rings-mobile-751b93e13ec264e69081adae429977df.webp";